"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutType = void 0;
var LayoutType;
(function (LayoutType) {
    LayoutType["indoor"] = "indoor";
    LayoutType["outdoor"] = "outdoor";
})(LayoutType || (exports.LayoutType = LayoutType = {}));
//# sourceMappingURL=LayoutType.js.map